/**
 * PlanCardSkeleton - Skeleton loading state for PlanCard component.
 */

import { Flex, Group, Paper, Skeleton, Stack } from "@mantine/core";

export const PlanCardSkeleton = () => {
  return (
    <Paper
      shadow="sm"
      radius="md"
      p="md"
      maw={1000}
      withBorder
      style={{ borderColor: "#228be6", borderWidth: 2 }}
    >
      <Stack gap="md">
        <Flex gap="sm" align="flex-start" justify="space-between">
          <Group gap="xs">
            <Skeleton height={24} width={180} radius="md" />
            <Skeleton height={20} width={70} radius="md" />
          </Group>
          <Skeleton height={32} width={130} radius="md" />
        </Flex>
        <Stack gap={4}>
          <Skeleton height={18} width={150} radius="md" />
          <Skeleton height={10} width="100%" radius="md" />
        </Stack>
        <Group gap="xs" justify="flex-end">
          <Skeleton height={24} width={140} radius="md" />
        </Group>
      </Stack>
    </Paper>
  );
};
